import { ImageOutlined } from '@material-ui/icons'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import styled from 'styled-components'
import { popularProducts } from '../data'
import Product from './Product'
import axios from "axios"

const Container = styled.div`
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`

const Products = ({cat,filters,sort}) => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilterProducts] = useState([]);

  useEffect(()=>{
    const getProducts = async ()=>{
      try{
        const res = await axios.get( cat ? `https://e-commere-api.onrender.com/api/products?category=${cat}`: "https://e-commere-api.onrender.com/api/products");
        setProducts(res.data);
      }catch (e){
        console.log(e);
      }
    }
    getProducts();
  },[cat]);

  useEffect(()=>{
    cat && setFilterProducts(
      products.slice(0,8).filter(item=> Object.entries(filters).every(([key,value])=>
        item[key].includes(value)
      ))
    )
  },[products, cat,filters]);

  useEffect(()=>{
    if(sort==="newest"){
      setFilterProducts((prev)=> [...prev].sort((a,b) => a.createdAt - b.createdAt));
    } else if(sort === "asc"){
      setFilterProducts((prev)=> [...prev].sort((a,b) => a.price - b.price));
    } else{
      setFilterProducts((prev)=> [...prev].sort((a,b) => b.price - a.price));
    }
  },[sort]);



  return (
    <Container>
        {cat ? filteredProducts.map((item)=>(
            <Product item={item} key={item.id}/>
        )) : products.map((item)=>(
            <Product item={item} key={item.id}/>
        )) };
    </Container>
  )
}

export default Products